import * as fbApp from 'firebase/app'
import * as fbAuth from 'firebase/auth'


const fb = fbApp.initializeApp(
  {
    apiKey: process.env.NEXT_PUBLIC_NEW_FB_API_KEY,
    authDomain: process.env.NEXT_PUBLIC_NEW_FB_AUTH_DOMAIN,
    projectId: process.env.NEXT_PUBLIC_NEW_FB_PROJECT_ID,
    appId: process.env.NEXT_PUBLIC_NEW_FB_APP_ID,
  },
  'auth-app'
)

export const firebaseAuth = fbAuth.getAuth(fb)

export default fb
